import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { RaisinContainer, Button as MuiButton } from '@raisin/components-lib';

export const Container = styled(RaisinContainer)(({ theme }) => ({
  paddingTop: theme.spacing(6),

  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(8),
  },

  [theme.breakpoints.up('lg')]: {
    paddingTop: theme.spacing(16),
  },
}));

export const ColumnsGrid = styled(Grid)(({ theme }) => ({
  flexDirection: 'column',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const ContentGrid = styled(Grid)(({ theme }) => ({
  '&.MuiGrid-item': {
    paddingRight: 0,
    paddingLeft: 0,

    [theme.breakpoints.up('md')]: {
      paddingRight: theme.spacing(6),
      paddingLeft: 0,
    },
  },

  '.contentItem': {
    paddingTop: theme.spacing(6),
  },
}));

export const Button = styled(MuiButton)(({ theme, $position }) => ({
  padding: 0,
  width: 'unset',
  marginTop: $position === 'bottom' ? theme.spacing(6) : 0,
  marginBottom: $position === 'top' ? theme.spacing(6) : 0,

  [theme.breakpoints.up('md')]: {
    marginTop: $position === 'bottom' ? theme.spacing(8) : 0,
    marginBottom: $position === 'top' ? theme.spacing(8) : 0,
  },

  [theme.breakpoints.up('lg')]: {
    marginTop: $position === 'bottom' ? theme.spacing(12) : 0,
    marginBottom: $position === 'top' ? theme.spacing(12) : 0,
  },
}));
